import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import client from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function VendorPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { client.get(`/vendors/${slug}`).then(r => setData(r.data)); }, [slug]);
  if (!data) return <div className="container-editorial py-24"><p className="label-uppercase">Loading…</p></div>;
  const { vendor, products } = data;

  return (
    <div>
      <section className="relative">
        <div className="w-full h-[50vh] md:h-[65vh] overflow-hidden">
          <img src={vendor.banner_image} alt={vendor.name} className="w-full h-full object-cover"/>
        </div>
        <div className="container-editorial -mt-24 relative z-10">
          <div className="bg-[#F7F5F0] border border-[#EAE5D9] p-8 md:p-12 max-w-3xl">
            <p className="label-uppercase text-[#B24C38]" data-testid="vendor-hechsher">{vendor.hechsher}</p>
            <h1 className="font-serif text-5xl md:text-6xl tracking-tighter mt-3" data-testid="vendor-name">{vendor.name}</h1>
            <p className="mt-4 text-[#4A4A4A] italic font-serif text-2xl leading-tight">"{vendor.tagline}"</p>
            <p className="mt-6 text-[#4A4A4A] leading-relaxed">{vendor.description}</p>
          </div>
        </div>
      </section>

      <section className="container-editorial mt-20">
        <div className="flex items-end justify-between border-b border-[#EAE5D9] pb-6 mb-12">
          <h2 className="font-serif text-3xl md:text-4xl tracking-tighter">The Collection</h2>
          <p className="label-uppercase text-[#4A4A4A]">{products.length} pieces</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-14">
          {products.map(p => <ProductCard key={p.id} product={p} testId={`vendor-product-${p.id}`}/>)}
        </div>
      </section>
    </div>
  );
}
